import React, { useEffect, useRef } from "react";
import * as filestack from 'filestack-js';
import { Wrapper, Loading, Icon } from '@/components';
import { ZuploaderOutputImage } from './zuploader';
import { loadBase64FromURL } from '@/utils';
import styles from './style.less';

interface FileStackProps {
  multiple?: boolean;
  onClose(): void;
  onConfirm: (images: ZuploaderOutputImage[]) => Promise<void>;
}

const FileStack: React.SFC<FileStackProps> = ({ onClose, onConfirm, multiple }) => {

  const picker = useRef<any>(null);

  useEffect(() => {
    const client = filestack.init('AEbSnRtPeRlSSNDk9fz54z');
    picker.current = client.picker({
      container: '#zuploader-fs',
      displayMode: filestack.PickerDisplayMode.inline,
      accept: "image/*",
      fromSources: ["local_file_system", "facebook", "instagram", "googledrive"],
      maxFiles: multiple ? 100 : 1,
      onOpen,
      async onUploadDone({ filesUploaded }) {
        await onConfirm(filesUploaded.map(item => ({
          image: item.url,
          size: item.size
        })));
        picker.current?.close();
      }
    });
    picker.current?.open();
  }, []);

  const onOpen = () => {
    requestAnimationFrame(() => {
      const doms: HTMLCollectionOf<Element> = document.getElementsByClassName('fsp-mobile-menu');
      if (doms.length > 0)
        (doms[0] as HTMLButtonElement).click();
      else
        onOpen();
    });
  }

  const handleClose = () => {
    picker.current?.close();
    onClose();
  }

  return (
    <Wrapper className={styles.fileStack}>
      <div
        id="zuploader-fs"
        className={styles.fileStackContent}
      />
      <div
        className={styles.fileStackClose}
        onClick={handleClose}
      >
        <Icon type="close" size={24}></Icon>
      </div>
      <Loading />
    </Wrapper>
  );
};

export default FileStack;
